"use client"
import { useEffect, useRef } from "react"
import { useLazyThirdParty } from "@/hooks/useLazyThirdParty"

interface MicrosoftClarityProps {
  nonce?: string
}

// Loads on every page. Matches the site posture (GA / Meta Pixel / booking widget): inject with
// data-cmp-ab="off" and let the consentmanager CMP govern cookies. (Previously gated on
// getConsentPrefs()?.analytics, but the CookieConsent banner that wrote that state is no longer
// rendered — consentmanager replaced it — so getConsentPrefs() was always null and Clarity never
// loaded for anyone.)
export function MicrosoftClarity({ nonce = '' }: MicrosoftClarityProps) {
  const loaded = useRef(false)
  const interacted = useLazyThirdParty()

  useEffect(() => {
    if (!interacted) return
    if (loaded.current) return
    loaded.current = true

    const w = window as typeof window & { clarity?: Function }
    w.clarity = w.clarity || function (...args: unknown[]) {
      (w.clarity as Function & { q?: unknown[] }).q = (w.clarity as Function & { q?: unknown[] }).q || []
      ;((w.clarity as Function & { q?: unknown[] }).q as unknown[]).push(args)
    }

    const script = document.createElement("script")
    script.async = true
    script.src = "https://www.clarity.ms/tag/wnh6b4hi38"
    script.setAttribute("data-cmp-ab", "off")
    if (nonce) script.nonce = nonce
    document.head.appendChild(script)
  }, [nonce, interacted])

  return null
}
